

























import Vue from 'vue'
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import OmnisearchResultSet from '@/modules/omnisearch/store/OmnisearchResultSet';
import OmnisearchResultItem from '@/modules/omnisearch/store/OmnisearchResultItem';


@Component
export default class ReservationsResultList extends Vue {
    @Prop({type: OmnisearchResultSet, default: () => new OmnisearchResultSet()})
    public set: OmnisearchResultSet
}
